const activities = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default activities;



// WEBPACK FOOTER //
// ./src/reducers/activities.js